import { render, staticRenderFns } from "./ImagePost.vue?vue&type=template&id=45b7e65c&scoped=true"
import script from "./ImagePost.vue?vue&type=script&lang=js"
export * from "./ImagePost.vue?vue&type=script&lang=js"
import style0 from "./ImagePost.vue?vue&type=style&index=0&id=45b7e65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7e65c",
  null
  
)

export default component.exports